<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.Query" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
            </el-form>
        </el-card>
        <el-card class="hotWidth" v-show="!isShowSearch">
            <span class="titleMes">热门知识——FAQ</span>
            <el-row>
                <el-col v-show="index<12" :span="8" v-for="(item, index) in hotFAQ" :key="index" :offset="index > 0 ? 0 : 0">
                    <el-card>
                        <!-- // {{item}} -->
                        <router-link :to="{ path: '/knowledgeDetail',
                                        query:{KnowledgeId:item.KnowledgeId,Version:item.Version} }">
                            <div class="titleColor">{{item.Title}}</div>
                        </router-link>
                        <p  class="topTitle" v-html="item.Body">{{item.Body}}</p>
                        <div><span class="authorRight">{{item.CreateUser}}</span><span>{{item.CreateTime}}</span></div>
                    </el-card>
                </el-col>
            </el-row>
        </el-card>
        <el-card v-show="isShowSearch">
            <span class="noDataClass" v-show="searchList.length<1">暂无数据</span>
            <div class="boxWidth">
                <div v-for="(item,index) in searchList" :key="index">
                    <div class="content">
                        <router-link :to="{ path: '/knowledgeDetail',
                                        query:{message:item} }">
                            <el-button class="titleLeft" type="text">{{item.Title}}</el-button>
                        </router-link>
                        <!-- <span>{{item.Body}}</span> -->
                        <div class="contentHeight">
                            <p v-html="item.Body">{{item.Body}}</p>
                        </div>

                        <div class="bottomMessage">
                            <span>{{item.CreateTime}}</span>
                            <span>{{item.CreateUser}}</span>
                            <span>浏览次数:{{item.ViewCount}}</span>
                            <span>来源:{{item.Origin | tableVal(knowledgeDic)}}</span>
                        </div>
                    </div>
                    <el-divider></el-divider>
                </div>
                <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageIndex"
                    :page-sizes="[10,20]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- <showKnowledgeMes :query="''"></showKnowledgeMes> -->
    </div>
</template>

<script>

    // import showKnowledgeMes from '../common/showKnowledgeMes.vue';
    import services from './knowledge.service.js';
    export default {
        data: function () {
            return {
                form:{
                    Query:'',
                    pageIndex:1,
                    pageSize:10
                },
                total:5,
                hotFAQ:[],//默认的热门知识
                searchList:[],//根据关键字搜索的结果
                isShowSearch:false,
            }
        },
        // components:{ showKnowledgeMes },
        created(){
            this.defaultList();
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //知识来源
            knowledgeDic(){
                return this.dictionary.KnowledgeOrigin;
            },
        },
        methods:{
            defaultList(){//默认查询
                services.knowledgeQuery({"Query":"","pageIndex":this.form.pageIndex,"pageSize":this.form.pageSize}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            search(){//根据关键字查询
                services.knowledgeQuery(this.form).then(res=>{
                    this.isShowSearch = true;
                    this.searchList = res.KnowledgeTable;
                    this.total = res.total;
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.search();
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.search();
            },
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .topTitle{
        width: 100%;
        height:100px;
        // overflow: hidden;
        // text-overflow:ellipsis;
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .topTitle:after{
        content: "..."; position: absolute; bottom: 0; right: 0; padding-left: 40px;
        background: -webkit-linear-gradient(left, transparent, #fff 55%);
        background: -o-linear-gradient(right, transparent, #fff 55%);
        background: -moz-linear-gradient(right, transparent, #fff 55%);
        background: linear-gradient(to right, transparent, #fff 55%);
    }
    .content{
        display: flex;
        flex-direction: column;
        &>span{
            margin-left: 10px;
        }
        &>div{
            margin-left: 10px;
            display: flex;
        }
    }
    .titleLeft{
        margin-left: 10px;
    }
    .hotWidth{
        width:90%;
    }
    .boxWidth{
        width:50%;
    }
    .noDataClass{
        margin: 20px 0 0 10px;
    }
    .titleMes{
        margin-left: 10px;
        font-size: 20px;
        color: #1C86EE;
    }
    .authorRight{
        margin-right: 20px;
    }
    .titleColor{
        color: #000080;
    }
    .bottomMessage{
        margin-top: 10px;
        &>span{
            margin-right: 15px;
        }
    }
    .contentHeight{
        height: 40px;
        overflow: hidden;
    }
</style>
